import { types } from "mobx-state-tree";

export const relationshipModel = types.model("Relationship", {
  id: types.string,
  type: types.string
});

export type RelationshipModelSnapshot = typeof relationshipModel["SnapshotType"];
